import { ContentType } from '@/@types/common'
import { type Post, PostStatus } from '@/@types/post'
import Warn2FilledIcon from '@/assets/warn-2-filled.svg?react'
import usePostNavigator from '@/utils/hooks/usePostNavigator'
import { type HTMLAttributes, type MouseEvent } from 'react'
import styles from './PostTarget.module.css'
import PostCard from './PostTargetCard/PostCard'

export interface PostTargetProps extends HTMLAttributes<HTMLDivElement> {
	data: Post | undefined
}

export default function PostTarget({ data, ...props }: PostTargetProps) {
	const navigateToPost = usePostNavigator()

	const handleCardClick = (e: MouseEvent) => {
		e.stopPropagation()

		if (!data?.target) {
			return
		}
		navigateToPost(data.target, e)
	}

	if (!data || !data.target || !data.targetType) {
		return null
	}

	if (data.target.status === PostStatus.DELETED) {
		return (
			<div className={styles.deletedContainer}>
				<Warn2FilledIcon className={styles.icon} />
				内容已删除
			</div>
		)
	}

	switch (data.targetType) {
		case ContentType.POST:
			return <PostCard data={data.target} onClick={handleCardClick} />
		case ContentType.REPOST:
			return <PostCard data={data.target} onClick={handleCardClick} />
		case ContentType.PERSONAL_UPDATE:
			return null
	}
}
